import React from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { useAuthContext } from '../Context/AuthContext'
import Auth from '../Pages/Auth'
import Panel from '../Pages/Panel'
const Router = () => {
  const { user } = useAuthContext();
 
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/auth/*' element={<Auth />} />
        <Route path='/panel/*' element={<Panel />} />
        <Route
          path='*'
          element={<Navigate to={user ? '/panel/' + user.type + '/' : '/auth/signin'} replace />}
        />
      </Routes>
    </BrowserRouter>
  )
}

export default Router
